import { AccountAddress } from '../../../../shared/types/modules/account';

export const ORBIT_ADDRESS_INCOMPLETE_MESSAGE =
    'La dirección está incompleta. Ingrese el tipo de vía y los tres números (principal, secundario y de placa) para continuar.';

export const isOrbitAddressStructurallyComplete = (
    values: Pick<AccountAddress, 'type1' | 'number1' | 'number2' | 'number3'>
) =>
    Boolean(
        values.type1 &&
            String(values.number1 || '').trim() &&
            String(values.number2 || '').trim() &&
            String(values.number3 || '').trim()
    );
